type Plan = {
  name: string;
  subtitle: string;
  price: string;
  priceNote: string;
  priceSuffix?: string;
  features: string[];
  cta: string;
  ctaNote: string;
  ctaStyle: "primary" | "outline";
};

const PLANS: Plan[] = [
  {
    name: "Starter",
    subtitle: "小規模チーム・ひとり担当者向け",
    price: "¥ 10,000",
    priceNote: "500人まで、文面生成は無制限（1人あたり20円）",
    features: [
      "スキルチェック：500人まで/月",
      "文面生成：無制限",
      "送信管理・レポート機能",
      "効果測定：すべての機能",
      "サポート：メールサポート",
    ],
    cta: "無料トライアル（100人分）で始める",
    ctaNote: "クレジットカード登録後、すぐに利用開始できます",
    ctaStyle: "primary",
  },
  {
    name: "Growth",
    subtitle: "大企業・RPO事業者向け",
    price: "6000通/月以上の方",
    priceNote: "大量送信・複数チーム運用・RPO案件に対応",
    priceSuffix: "",
    features: [
      "ボリュームディスカウントあり",
      "送信管理・レポート機能",
      "効果測定：すべての機能",
      "サポート：優先サポート",
    ],
    cta: "料金を相談する",
    ctaNote: "運用規模に応じて個別にご提案します",
    ctaStyle: "outline",
  },
];

export function PricingSection() {
  return (
    <section className="bg-white" id="pricing">
      <div className="mx-auto max-w-[1200px] px-6 py-24">
        <h2 className="text-center text-[28px] font-bold tracking-tight md:text-[34px]">
          プラン・料金
        </h2>

        <div className="mx-auto mt-8 max-w-[820px] rounded-2xl border border-brand-200 bg-brand-50 px-5 py-4 text-center shadow-soft">
          <div className="text-[15px] font-bold text-brand-700">
            クレジットカード登録で、100人分まで全機能を利用可能
          </div>
          <p className="mt-2 text-[12px] leading-relaxed text-ink-600">
            スキルチェック、文面生成、送信管理、レポート機能、効果測定まで試せます。
          </p>
        </div>

        <div className="mx-auto mt-12 grid max-w-[820px] grid-cols-1 gap-5 md:grid-cols-2">
          {PLANS.map((plan) => (
            <PricingCard key={plan.name} plan={plan} />
          ))}
        </div>
        <p className="mt-6 text-center text-[11px] text-ink-400">
          ※表示価格は税込。クレジットカード登録で100人分まで全機能を利用できます。
        </p>
      </div>
    </section>
  );
}

function PricingCard({ plan }: { plan: Plan }) {
  const cardClass =
    plan.ctaStyle === "primary"
      ? "flex h-full flex-col rounded-2xl border-2 border-brand-500 bg-brand-50/60 p-8 shadow-pop"
      : "flex h-full flex-col rounded-2xl border border-ink-200 bg-white p-8";
  const buttonClass =
    plan.ctaStyle === "primary"
      ? "btn-primary mt-5 h-12 w-full rounded-lg text-[13px] font-bold text-white"
      : "mt-5 h-12 w-full rounded-lg border border-ink-300 text-[13px] font-semibold text-ink-800 hover:bg-ink-50";

  return (
    <div className={cardClass}>
      <div className="text-center text-[17px] font-bold text-brand-600">{plan.name}</div>
      <div className="mt-1 text-center text-[13px] font-semibold text-ink-600">{plan.subtitle}</div>
      <div className="mt-6 text-center">
        <span className="num text-[32px] font-bold">{plan.price}</span>
        {plan.priceSuffix === "" ? null : (
          <span className="text-[13px] text-ink-500">{plan.priceSuffix ?? " / 月"}</span>
        )}
      </div>
      <p className="mx-auto mt-3 max-w-[280px] text-center text-[12px] font-semibold leading-relaxed text-ink-600">
        {plan.priceNote}
      </p>
      <button className={buttonClass} type="button">
        {plan.cta}
      </button>
      <p className="mt-4 text-center text-[11px] font-semibold leading-relaxed text-ink-500">
        {plan.ctaNote}
      </p>
      <ul className="mt-6 space-y-2 text-[12px] text-ink-700">
        {plan.features.map((f) => (
          <li className="flex items-center gap-2" key={f}>
            <span className="mi text-[14px] text-brand-600">check</span>
            {f}
          </li>
        ))}
      </ul>
    </div>
  );
}
